import { render, staticRenderFns } from "./test6-1.vue?vue&type=template&id=068715f8&scoped=true"
import script from "./test6-1.vue?vue&type=script&lang=js"
export * from "./test6-1.vue?vue&type=script&lang=js"
import style0 from "./test6-1.vue?vue&type=style&index=0&id=068715f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068715f8",
  null
  
)

export default component.exports